"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectRoutingStack_1 = __importDefault(require("../../shared/appStateSelectRoutingStack"));
const executeTransition_1 = __importDefault(require("../../shared/executeTransition"));
const valueIsRoutingTransition_1 = __importDefault(require("../../typeAssertions/valueIsRoutingTransition"));
const valueIsRoutingTransitionSpeed_1 = __importDefault(require("../../typeAssertions/valueIsRoutingTransitionSpeed"));
const AppStateConstants_1 = require("../../types/AppStateConstants");
const buildBackPage = ({ store, entryVars: { transition: transitionType, transitionSpeed }, }) => {
    const currentStack = (0, appStateSelectRoutingStack_1.default)(store.getState());
    if (currentStack.length < 2) {
        return;
    }
    if (transitionType !== undefined && !(0, valueIsRoutingTransition_1.default)(transitionType)) {
        return;
    }
    if (transitionSpeed !== undefined && !(0, valueIsRoutingTransitionSpeed_1.default)(transitionSpeed)) {
        return;
    }
    if (transitionType) {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.ROUTING_SET_CURRENT_ROUTE_TRANSITION,
            payload: {
                type: transitionType,
                speed: transitionSpeed,
            },
        });
        (0, executeTransition_1.default)(transitionSpeed).then(() => {
            store.dispatch({
                type: AppStateConstants_1.AppStateConstants.ROUTING_GO_BACK,
            });
        });
        return;
    }
    store.dispatch({
        type: AppStateConstants_1.AppStateConstants.ROUTING_GO_BACK,
    });
};
exports.default = buildBackPage;
